// import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';

// @ts-expect-error untyped dependency
import withPermissionsTooltip from 'FormsCommonComponents/withPermissionsTooltip';
// import isAcceptanceTest from 'forms-utils-lib/localStorage/isAcceptanceTest';
import useShowFreeStarterEmptyState from 'FormsUI/components/hooks/zeroState/useShowFreeStarterEmptyState';
import EmptyStateButton from 'FormsUI/components/dashboard/zeroState/freeStarter/EmptyStateButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const UIButtonWithTooltip = withPermissionsTooltip(Button);
const FormCreationButton = ({
  formsWriteAccess = false,
  onClick,
  isRequestStatePending = false,
  isPortalZeroState = false,
  push,
  size = 'small'
}) => {
  const showFreeStarterEmptyState = useShowFreeStarterEmptyState(isPortalZeroState);
  if (showFreeStarterEmptyState && isPortalZeroState) {
    return /*#__PURE__*/_jsx(EmptyStateButton, {
      formsWriteAccess: formsWriteAccess,
      isRequestStatePending: isRequestStatePending,
      isPortalZeroState: isPortalZeroState,
      push: push,
      size: size
    });
  }
  return /*#__PURE__*/_jsx(UIButtonWithTooltip, {
    "data-test-id": "form-creation-button",
    use: "primary",
    size: size,
    hasPermission: formsWriteAccess,
    disabled: isRequestStatePending,
    onClick: onClick,
    "data-selenium-test": "create-form",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `formCreation.${isPortalZeroState ? 'formCreationCtaZeroState' : 'formCreationCta'}`
    })
  });
};
export default FormCreationButton;